import "./index.scss";
import Hook from "./usePricingOption";
import helper from "./pricingOptionHelper";
import StatusChip from "../StatusChip";

function PricingOption(props) {
  const { name, isSelected, onChange } = props;
  const { label, price, period, badge } = Hook.usePricingOption(props);

  return (
    <label className={`pricing-option ${isSelected ? "pricing-option--selected" : ""}`}>
      <div className="pricing-option__info">
        <span className="pricing-option__name">{label}</span>
        {badge && <StatusChip status={helper.BADGE_VARIANT} label={badge} />}
      </div>
      <div className="pricing-option__pricing">
        <span className="pricing-option__price">{price}</span>
        <span className="pricing-option__period">{period}</span>
      </div>
      <input
        type="radio"
        name={name}
        className="pricing-option__radio"
        checked={isSelected}
        onChange={onChange}
      />
    </label>
  );
}

export default PricingOption;
